const state = {
    netflixShowFlag: false,
    netflixPopType: null,
    netflixTransactionKey: null,
    product_email: null,
    picPopFlag: false,
    picPopType: null,
    picUrl: null
};

const getters = {
    netflixShowFlag: (state) => state.netflixShowFlag,
    netflixPopType: (state) => state.netflixPopType,
    product_email: (state) => state.product_email,
    picPopFlag: (state) => state.picPopFlag,
    picPopType: (state) => state.picPopType,
    picUrl: (state) => state.picUrl
};

const mutations = {
    setNetflixShowFlag(state, showFlag) {
        state.netflixShowFlag = showFlag;
    },
    setNetflixPopType(state, popType) {
        state.netflixPopType = popType;
    },
    setNetflixTransactionKey(state, transactionKey) {
        state.netflixTransactionKey = transactionKey;
    },
    setProductEmail(state, email) {
        state.product_email = email;
    },
    setPicPopFlag(state, payload) {
        state.picPopFlag = payload
    },
    setPicPopType(state, payload) {
        state.picPopType = payload
    },
    setPicUrl(state, payload) {
        state.picUrl = payload
    }
};

const actions = {
    updateNetflixShowFlag({commit}, showFlag) {
        commit('setNetflixShowFlag', showFlag);
    },
    updateNetflixPopType({commit}, popType) {
        commit('setNetflixPopType', popType);
    },
    updateNetflixTransactionKey({commit}, transactionKey) {
        commit('setNetflixTransactionKey', transactionKey);
    },
    updateNetFlixProductEmail({commit}, email) {
        commit('setProductEmail', email);
    },
    updatePicPopFlag({commit}, payload) {
        commit('setPicPopFlag', payload)
    },
    updatePicPopType({commit}, payload) {
        commit('setPicPopType', payload)
    },
    updatePicUrl({commit}, payload) {
        commit('setPicUrl', payload)
    },

};

export default {
    namespaced: true, // 使用命名空间
    state,
    getters,
    mutations,
    actions,
};
